import ExcelJS from "exceljs";

export type ExcelColumn = { label: string; value: string };
export type ExcelSheet = {
  name: string;
  data: Record<string, unknown>[];
  columns: ExcelColumn[];
};

/**
 * Export data to an Excel (.xlsx) file and trigger download in the browser.
 */
export async function exportToExcel(
  filename: string,
  sheets: ExcelSheet[]
): Promise<void> {
  const workbook = new ExcelJS.Workbook();

  for (const sheet of sheets) {
    const worksheet = workbook.addWorksheet(sheet.name);
    const headers = sheet.columns.map((col) => col.label);
    worksheet.addRow(headers);

    for (const row of sheet.data) {
      const values = sheet.columns.map((col) => {
        const val = row[col.value];
        return val !== undefined && val !== null ? String(val) : "";
      });
      worksheet.addRow(values);
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `${filename}.xlsx`;
  link.click();
  URL.revokeObjectURL(url);
}
